import React from 'react'
import AssetIcon from './assets/icons/svg/AssetIcon'
import BlacklistIcon from './assets/icons/svg/BlacklistIcon'
import CalendarIcon from './assets/icons/svg/CalendarIcon'
import CampaignIcon from './assets/icons/svg/CampaignIcon'
import CheckInCountIcon from './assets/icons/svg/CheckInCountIcon'
import CheckInReportIcon from './assets/icons/svg/CheckInReportIcon'
import CircleCheckIcon from './assets/icons/svg/CircleCheckIcon'
import CompensationIcon from './assets/icons/svg/CompensationIcon'
import DocumentIcon from './assets/icons/svg/DocumentIcon'
import EventIcon from './assets/icons/svg/EventIcon'
import ExportMyHRIcon from './assets/icons/svg/ExportMyHRIcon'
import ExportReportIcon from './assets/icons/svg/ExportReportIcon'
import ExportSalesforceIcon from './assets/icons/svg/ExportSalesforceIcon'
import HistoryIcon from './assets/icons/svg/HistoryIcon'
import HolidayIcon from './assets/icons/svg/HolidayIcon'
import ImportIcon from './assets/icons/svg/ImportIcon'
import ImportUpdateIcon from './assets/icons/svg/ImportUpdateIcon'
import MovePosition from './assets/icons/svg/MovePosition'
import QRCodeIcon from './assets/icons/svg/QRCodeIcon'
import QuestionIcon from './assets/icons/svg/QuestionIcon'
import RejectDocIcon from './assets/icons/svg/RejectDocIcon'
import ReportListIcon from './assets/icons/svg/ReportListIcon'
import ResultIcon from './assets/icons/svg/ResultIcon'
import SaleSupportIcon from './assets/icons/svg/SaleSupportIcon'
import SourceIcon from './assets/icons/svg/SourceIcon'
import StatisticIcon from './assets/icons/svg/StatisticIcon'
import TrainingReportIcon from './assets/icons/svg/TrainingReportIcon'
import UserBorderIcon from './assets/icons/svg/UserBorderIcon'
import UserCheck from './assets/icons/svg/UserCheck'
import UserGroup from './assets/icons/svg/UserGroup'
import UserGroupSetting from './assets/icons/svg/UserGroupSetting'
import UserIcon from './assets/icons/svg/UserIcon'
import UserPlus from './assets/icons/svg/UserPlus'
import UserWithTie from './assets/icons/svg/UserWithTie'
import ConfigurationIcon from './assets/icons/svg/ConfigurationIcon'
import MenuIcon from './assets/icons/svg/MenuIcon'
import ProvinceIcon from './assets/icons/svg/ProvinceIcon'
import LocationPointerIcon from './assets/icons/svg/LocationPointerIcon'

const BACK_OFFICE_CONTENT = {
  CANDIDATE: {
    CandidatePc: React.lazy(() => import('./views/back-office/candidate/candidate-pc/CandidatePc')),
    CandidateTelesales: React.lazy(() => import('./views/back-office/candidate/candidate-telesales/CandidateTelesales')),
    CandidateSAB: React.lazy(() => import('./views/back-office/candidate/candidate-sab/CandidateSab'))
  },
  SALE_INFO: {
    SalesinfoPc: React.lazy(() => import('./views/back-office/salesinfo/hired-pc/HiredPc')),
    SalesinfoSab: React.lazy(() => import('./views/back-office/salesinfo/hired-sab/HiredSab')),
    SalesinfoTelesales: React.lazy(() => import('./views/back-office/salesinfo/hired-telesales/HiredTelesales')),
    SalesinfoTeleChubb: React.lazy(() => import('./views/back-office/salesinfo/hired-tele-chubb/HiredTeleChubb')),
    SalesinfoTeleMotor: React.lazy(() => import('./views/back-office/salesinfo/hired-telesales-motor/HiredTelesalesMotor')),
    SalesinfoTeleAig: React.lazy(() => import('./views/back-office/salesinfo/hired-tele-aig/HiredTeleAig'))
  },
  REPORT: {
    CampaignReport: React.lazy(() => import('./views/back-office/report/campaign-report/CampaignReport')),
    CompensationReport: React.lazy(() => import('./views/back-office/report/compensation-report/CompensationReport')),
    PcQuestions: React.lazy(() => import('./views/back-office/report/pc-questions/PcQuestions')),
    PcStatistics: React.lazy(() => import('./views/back-office/report/pc-statistics/PcStatistics')),
    ReportList: React.lazy(() => import('./views/back-office/report/report-list/ReportList')),
    SalesSupport: React.lazy(() => import('./views/back-office/report/sales-support/SalesSupport')),
    ExaminationReport: React.lazy(() => import('./views/back-office/report/examination-report/ExaminationReport')),
    TrainingReport: React.lazy(() => import('./views/back-office/report/training-report/TrainingReport'))
  },
  EXPORT: {
    ExportOtherSystems: React.lazy(() => import('./views/back-office/export/export-to-other-systems/ExportToOtherSystems')),
    ExportForSalesforce: React.lazy(() => import('./views/back-office/export/export-for-salesforce/ExportForSalesforce')),
    ExportForMyHR: React.lazy(() => import('./views/back-office/export/export-for-myhr/ExportForMyhr'))
  },
  EVENT: {
    GenerateQR: React.lazy(() => import('./views/back-office/event/generate-qr/UIGenerateQR')),
    CheckInReportDetail: React.lazy(() => import('./views/back-office/event/check-in-report-detail/CheckInReportDetail')),
    CheckInReportByArea: React.lazy(() => import('./views/back-office/event/check-in-report-by-area/CheckInReportByArea')),
    CheckInCount: React.lazy(() => import('./views/back-office/event/check-in-count/CheckInCount')),
    OnboardingReport: React.lazy(() => import('./views/back-office/event/onboarding-report/UIOnboardingReport'))
  },
  SETTINGS: {
    TrainingScheduleSetting: React.lazy(() =>
      import('./views/back-office/settings/setting-training-schedule/TrainingScheduleSetting')
    )
  },
  OPERATION: {
    VerifyExamination: React.lazy(() => import('./views/back-office/operation/verify-examination/UIVerifyExamination')),
    VerifyTraning: React.lazy(() => import('./views/back-office/operation/verify-examination/UIVerifyTraining'))
  },
  MANAGEMENT: {
    ManageUser: React.lazy(() => import('./views/back-office/Management/User/UIManageUser')),
    ManageRole: React.lazy(() => import('./views/back-office/Management/Role/UIManageRole')),
    ManageRecruiter: React.lazy(() => import('./views/back-office/Management/Recruiter/UIManageRecruiter')),
    ManageRecruiterPosition: React.lazy(() =>
      import('./views/back-office/Management/RecruiterPosition/UIManageRecruiterPosition')
    ),
    ManageEmployeeLeave: React.lazy(() => import('./views/back-office/Management/EmployeeLeave/UIManageEmployeeLeave')),
    ManageEmployeeLevel: React.lazy(() => import('./views/back-office/Management/EmployeeLevel/UIManageEmployeeLevel')),
    ManageHunter: React.lazy(() => import('./views/back-office/Management/Hunter/UIManageHunter')),
    ManageEvent: React.lazy(() => import('./views/back-office/Management/Event/UIManageEvent')),
    ManageRejectReason: React.lazy(() => import('./views/back-office/Management/RejectReason/UIManageRejectReason')),
    ManageResignReason: React.lazy(() => import('./views/back-office/Management/ResignReason/UIManageResignReason')),
    ManageGroupPosition: React.lazy(() => import('./views/back-office/Management/GroupPosition/UIManageGroupPosition')),
    ManageProvince: React.lazy(() => import('./views/back-office/Management/Province/UIManageProvince')),
    ManageAgentPosition: React.lazy(() => import('./views/back-office/Management/AgentPosition/UIManageAgentPosition')),
    ManageReport: React.lazy(() => import('./views/back-office/Management/ReportList/UIManageReport')),
    ManageFile: React.lazy(() => import('./views/back-office/Management/FileList/UIManageFile')),
    ImportEmployee: React.lazy(() => import('./views/back-office/Management/ImportEmployment/UIImportEmployee')),
    ManageBlacklits: React.lazy(() => import('./views/back-office/Management/Blacklist/UIManageBlacklist')),
    ImportCandidate: React.lazy(() => import('./views/back-office/Management/ImportCandidate/UIImportCandidate')),
    Batch: React.lazy(() => import('./views/back-office/Management/Batch/UIManageBatch')),
    Source: React.lazy(() => import('./views/back-office/Management/Source/UIManageSource')),
    ImportInterView: React.lazy(() => import('./views/back-office/Management/ImportInterview/UIImportInterView')),
    ManageHoliday: React.lazy(() => import('./views/back-office/Management/Holiday/UIManageHoliday')),
    SyncDatatoMyHR: React.lazy(() => import('./views/back-office/Management/SyncDatatoMyHR/UISyncDatatoMyHR')),
    GenStructure: React.lazy(() => import('./views/back-office/Management/GenStructure/UIManageGenStructure')),
    ManageConsent: React.lazy(() => import('./views/back-office/Management/Consent/UIManageConsent')),
    ManageWelcomeLetter: React.lazy(() => import('./views/back-office/Management/WelcomeLetter/UIManageWelcomeLetter')),
    ManageiReferUser: React.lazy(() => import('./views/back-office/Management/iReferUser/UIManageiReferUser')),
    ManageiReferParter: React.lazy(() => import('./views/back-office/Management/iReferPartner/UIManageiReferPartner')),
    ManageApproveFlow: React.lazy(() => import('./views/back-office/Management/Approveflow/UIManageApproveFlow')),
    AutoTerminate: React.lazy(() => import('./views/back-office/Management/AutoTerminate/UIAutoTerminate')),
    ManageATTemplate: React.lazy(() => import('./views/back-office/Management/ManageATTemplate/UIManageATTemplate')),
    CompensationScheme: React.lazy(() =>
      import('./views/back-office/Management/CompensationScheme/UIMasterCompensationScheme')
    ),
    AutoTerminateLog: React.lazy(() => import('./views/back-office/Management/AutoTerminateLog/UIAutoTerminateLog')),
    UploadTerminateFTE: React.lazy(() => import('./views/back-office/Management/UploadTerminateFTE/UIUploadTerminateFTE')),
    AgentListLog: React.lazy(() => import('./views/back-office/Management/AgentListHistory/UIAgentListHistory')),
    ManageMasterTeleArea: React.lazy(() =>
      import('./views/back-office/Management/ManageMasterTeleArea/UIManageMasterTeleArea')
    ),
    ManageMasterBank: React.lazy(() => import('./views/back-office/Management/ManageMasterBank/UIManageMasterBank')),
    Education: React.lazy(() => import('./views/back-office/Management/Education/UIManageEducation')),
    ImportPicture: React.lazy(() => import('./views/back-office/Management/ImportPicture/UIImportPicture'))
  },
  CONFIGURATION: {
    Configuration: React.lazy(() => import('./views/back-office/Configulation/Configuration/UIManageConfig')),
    Menu: React.lazy(() => import('./views/back-office/Configulation/Menu/UIManageMenu')),
    Asset: React.lazy(() => import('./views/back-office/Configulation/Asset/UIManageAsset')),
    ManageListOfValue: React.lazy(() => import('./views/back-office/Configulation/ListOfValue/UIManageListOfValue')),
    ManageArea: React.lazy(() => import('./views/back-office/Configulation/SfArea/UIManageArea')),
    PageType: React.lazy(() => import('./views/back-office/Configulation/ApplicationPageType/UIManageApplicationPageType')),
    Cors: React.lazy(() => import('./views/back-office/Configulation/Cors/UIManageCors')),
    LogPii: React.lazy(() => import('./views/back-office/Configulation/LogPii/UILogPii'))
  },
  REUSABLE: {
    Import: React.lazy(() => import('./reusable/Import/UIImport'))
  }
}

const FONT_OFFICE_CONTENT = {
  Homepage: React.lazy(() => import('./views/front-office/homepage/homepage')),
  RegisterMain: React.lazy(() => import('./views/front-office/register/RegisterMain')),
  ContractReferral: React.lazy(() => import('./views/front-office/ContractReferral/UIContractReferral')),
  DocumentsUpload: React.lazy(() => import('./views/front-office/DocumentsUpload/UIDocumentsUpload')),
  NotFound: React.lazy(() => import('./views/pages/NotfoundPage'))
}

const HEADER = {
  HomeHeader: React.lazy(() => import('./views/front-office/HomeHeader')),
  BackOfficeNav: React.lazy(() => import('./views/back-office/BackOfficeHeader'))
}

//perm is data of field MenuName in table m_menu
const routes = [
  {
    path: '/',
    exact: true,
    name: 'หน้าหลัก',
    type: 'PC',
    component: FONT_OFFICE_CONTENT.Homepage,
    header: HEADER.HomeHeader
  },
  {
    path: '/telesales',
    exact: true,
    name: 'หน้าหลัก',
    type: 'TSR',
    component: FONT_OFFICE_CONTENT.Homepage,
    header: HEADER.HomeHeader
  },
  {
    path: '/pc',
    exact: true,
    name: 'scb-protect-career',
    component: FONT_OFFICE_CONTENT.RegisterMain,
    header: HEADER.HomeHeader
  },
  {
    path: '/sm',
    exact: true,
    name: 'SM',
    component: FONT_OFFICE_CONTENT.RegisterMain,
    header: HEADER.HomeHeader
  },
  {
    path: '/telesaleslife',
    exact: true,
    name: 'Telesales Life',
    component: FONT_OFFICE_CONTENT.RegisterMain,
    header: HEADER.HomeHeader
  },
  {
    path: '/telesalesmotor',
    exact: true,
    name: 'Telesales Motor',
    component: FONT_OFFICE_CONTENT.RegisterMain,
    header: HEADER.HomeHeader
  },
  {
    path: '/telesales-chubb',
    exact: true,
    name: 'Telesales Chubb',
    component: FONT_OFFICE_CONTENT.RegisterMain,
    header: HEADER.HomeHeader
  },
  {
    path: '/sab',
    exact: true,
    name: 'sab',
    component: FONT_OFFICE_CONTENT.RegisterMain,
    header: HEADER.HomeHeader
  },
  {
    path: '/contractreferral',
    exact: true,
    name: 'Contract Referral',
    component: FONT_OFFICE_CONTENT.ContractReferral,
    header: HEADER.HomeHeader
  },
  {
    path: '/Documents-Upload/:token',
    exact: true,
    name: 'Documents Upload',
    component: FONT_OFFICE_CONTENT.DocumentsUpload,
    header: HEADER.HomeHeader
  },
  {
    path: '/Back-office/Candidate Info/Candidate-Pc',
    exact: true,
    perm: 'Candidate-Pc',
    name: 'Candidate PC',
    icon: <UserWithTie color="#fff" />,
    component: BACK_OFFICE_CONTENT.CANDIDATE.CandidatePc,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Candidate Info/Candidate-Telesales',
    exact: true,
    perm: 'Candidate-Telesales',
    name: 'Candidate Telesales',
    type: 'TSR',
    icon: <UserIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.CANDIDATE.CandidateTelesales,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Candidate Info/Candidate-SAB',
    exact: true,
    perm: 'Candidate-SAB',
    name: 'Candidate SAB',
    type: 'SAB',
    icon: <UserBorderIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.CANDIDATE.CandidateSAB,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Info/Hired-PC',
    exact: true,
    perm: 'Hired-PC',
    name: 'Employee PC',
    icon: <UserWithTie color="#fff" />,
    component: BACK_OFFICE_CONTENT.SALE_INFO.SalesinfoPc,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Info/Hired-SAB',
    exact: true,
    perm: 'Hired-SAB',
    name: 'Employee SAB',
    icon: <UserBorderIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.SALE_INFO.SalesinfoSab,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Info/Hired-Telesales',
    exact: true,
    perm: 'Hired-Telesales',
    name: 'Employee Telesales',
    icon: <UserIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.SALE_INFO.SalesinfoTelesales,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Info/Hired-Tele-Chubb',
    exact: true,
    perm: 'Hired-Tele-Chubb',
    name: 'Employee Telesales Non-Life (CHUBB)',
    icon: <UserIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.SALE_INFO.SalesinfoTeleChubb,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Info/Hired-Tele-Aig',
    exact: true,
    perm: 'Hired-Tele-Aig',
    name: 'Employee Telesales Non-Life (AIG)',
    icon: <UserIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.SALE_INFO.SalesinfoTeleAig,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Info/Hired-Tele-Motor',
    exact: true,
    perm: 'Hired-Tele-Motor',
    name: 'Employee Telesales Motor',
    icon: <UserIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.SALE_INFO.SalesinfoTeleMotor,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Report/PC-Statistics',
    exact: true,
    perm: 'PC-Statistics',
    name: 'PC Statistics',
    component: BACK_OFFICE_CONTENT.REPORT.PcStatistics,
    header: HEADER.BackOfficeNav,
    icon: <StatisticIcon color="#fff" />
  },
  {
    path: '/Back-office/Report/PC-Questions',
    exact: true,
    perm: 'PC-Questions',
    name: 'PC Questions',
    component: BACK_OFFICE_CONTENT.REPORT.PcQuestions,
    header: HEADER.BackOfficeNav,
    icon: <QuestionIcon color="#fff" />
  },
  {
    path: '/Back-office/Report/Report-List',
    exact: true,
    perm: 'Report-List',
    name: 'Report List',
    component: BACK_OFFICE_CONTENT.REPORT.ReportList,
    icon: <ReportListIcon color="#fff" />,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Licensing/ExaminationReport',
    exact: true,
    perm: 'ExaminationReport',
    name: 'Licensing Examination Report',
    component: BACK_OFFICE_CONTENT.REPORT.ExaminationReport,
    icon: <DocumentIcon color="#fff" />,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Event/Training-Report',
    exact: true,
    perm: 'Training-Report',
    name: 'Training Report',
    component: BACK_OFFICE_CONTENT.REPORT.TrainingReport,
    icon: <TrainingReportIcon color="#fff" />,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Report/Sales-Support',
    exact: true,
    perm: 'Sales-Support',
    name: 'Sales Support',
    component: BACK_OFFICE_CONTENT.REPORT.SalesSupport,
    header: HEADER.BackOfficeNav,
    icon: <SaleSupportIcon color="#fff" />
  },
  {
    path: '/Back-office/Report/Campaign-Report',
    exact: true,
    perm: 'Campaign-Report',
    name: 'Campaign Report',
    component: BACK_OFFICE_CONTENT.REPORT.CampaignReport,
    header: HEADER.BackOfficeNav,
    icon: <CampaignIcon color="#fff" />
  },
  {
    path: '/Back-office/Report/Compensation-Report',
    exact: true,
    perm: 'Compensation-Report',
    name: 'Sales Structure Report',
    component: BACK_OFFICE_CONTENT.REPORT.CompensationReport,
    header: HEADER.BackOfficeNav,
    icon: <CompensationIcon color="#fff" />
  },
  {
    path: '/Back-office/Export/Export-To-Other-Systems',
    exact: true,
    name: 'Export To Other Systems',
    icon: <ExportReportIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.EXPORT.ExportOtherSystems,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Export/Export-For-Salesforce',
    exact: true,
    name: 'Export For Salesforce',
    icon: <ExportSalesforceIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.EXPORT.ExportForSalesforce,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Export/Export-For-MyHR',
    exact: true,
    name: 'Export For MyHR',
    icon: <ExportMyHRIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.EXPORT.ExportForMyHR,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Event/Generate-QR',
    exact: true,
    name: 'Generate QR',
    perm: 'Generate-QR',
    icon: <QRCodeIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.EVENT.GenerateQR,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Event/Check-In-Report-Detail',
    exact: true,
    perm: 'Check-In-Report-Detail',
    name: 'Check In Report Detail',
    icon: <CheckInReportIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.EVENT.CheckInReportDetail,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Event/Check-In-Report-By-Area',
    exact: true,
    perm: 'Check-In-Report-By-Area',
    name: 'Check In Report By Area',
    icon: <CheckInReportIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.EVENT.CheckInReportByArea,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Event/Check-In-Count',
    exact: true,
    perm: 'Check-In-Count',
    name: 'Check In Count',
    icon: <CheckInCountIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.EVENT.CheckInCount,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Employee Event/Onboarding-Report',
    exact: true,
    perm: 'Onboarding-Report',
    name: 'Onboarding Report',
    icon: <DocumentIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.EVENT.OnboardingReport,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Licensing/TrainingSchedules',
    exact: true,
    perm: 'TrainingSchedules',
    name: 'Licensing Training Schedules',
    icon: <CalendarIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.SETTINGS.TrainingScheduleSetting,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Licensing/VerifyExaminationLicense',
    perm: 'VerifyExaminationLicense',
    exact: true,
    name: 'Verify Examination License',
    icon: <CircleCheckIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.OPERATION.VerifyExamination,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Licensing/VerifyTraining',
    exact: true,
    perm: 'VerifyTraining',
    name: 'Verify Training',
    icon: <UserCheck color="#fff" />,
    component: BACK_OFFICE_CONTENT.OPERATION.VerifyTraning,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/User',
    exact: true,
    perm: 'User',
    name: 'User Management',
    icon: <UserPlus color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageUser,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Role',
    exact: true,
    perm: 'Role',
    name: 'Assign Role & Permission',
    icon: <UserGroup color="#fff" size={45} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageRole,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Recruiter',
    exact: true,
    perm: 'Recruiter',
    name: 'Recruiter Management',
    icon: <UserIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageRecruiter,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Referrer',
    exact: true,
    perm: 'Referrer',
    name: 'Referrer Management',
    icon: <UserIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageHunter,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/PositionsManagement',
    exact: true,
    perm: 'PositionsManagement',
    name: 'Positions Management',
    icon: <UserGroupSetting color="#fff" size={45} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageRecruiterPosition,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/EmployeeLeave',
    exact: true,
    perm: 'EmployeeLeave',
    name: 'Employee Leave',
    icon: <UserGroupSetting color="#fff" size={45} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageEmployeeLeave,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/EmployeeLevel',
    exact: true,
    perm: 'EmployeeLevel',
    name: 'Employee Level',
    icon: <UserGroupSetting color="#fff" size={45} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageEmployeeLevel,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Event',
    exact: true,
    perm: 'Event',
    name: 'Event Management',
    icon: <EventIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageEvent,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Review-Reject-Reason',
    exact: true,
    perm: 'Review-Reject-Reason',
    name: 'Master Reject Reason',
    icon: <RejectDocIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageRejectReason,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Import-Employee',
    exact: true,
    perm: 'Import-Employee',
    name: 'Import Employee',
    icon: <ImportIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ImportEmployee,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Update-Employee',
    exact: true,
    perm: 'Update-Employee',
    name: 'Update Employee',
    icon: <ImportUpdateIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ImportEmployee,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Import-Picture',
    exact: true,
    perm: 'Import-Picture',
    name: 'Import Picture',
    icon: <ImportIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ImportPicture,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Blacklist',
    exact: true,
    perm: 'Blacklist',
    name: 'Blacklist Management',
    icon: <BlacklistIcon color="#fff" size={35} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageBlacklits,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Import-Candidate',
    exact: true,
    perm: 'Import-Candidate',
    name: 'Import Candidate',
    icon: <ImportIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ImportCandidate,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Sales Support/Import-iFWD',
    exact: true,
    perm: 'Import-iFWD',
    name: 'Import iFWD',
    icon: <ImportIcon color="#fff" />,
    props: { textHeader: 'Import iFWD', apiPath: 'iFWD' },
    component: BACK_OFFICE_CONTENT.REUSABLE.Import,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Sales Support/Import-BoltTech',
    exact: true,
    perm: 'Import-BoltTech',
    name: 'Import BoltTech',
    icon: <ImportIcon color="#fff" />,
    props: { textHeader: 'Import BoltTech', apiPath: 'BoltTech' },
    component: BACK_OFFICE_CONTENT.REUSABLE.Import,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Batch',
    exact: true,
    perm: 'Batch',
    name: 'Master Batch',
    icon: <DocumentIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.Batch,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Source',
    exact: true,
    perm: 'Source',
    name: 'Master Source',
    icon: <SourceIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.Source,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Import-Interview',
    exact: true,
    perm: 'Import-Interview',
    name: 'Import Interview Results',
    icon: <ResultIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ImportInterView,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Holiday',
    exact: true,
    perm: 'Holiday',
    name: 'Master Holiday',
    icon: <HolidayIcon color="#fff" size={35} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageHoliday,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Resign-Reason',
    exact: true,
    perm: 'Resign-Reason',
    name: 'Master Resign Reason',
    icon: <RejectDocIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageResignReason,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Group-Position',
    exact: true,
    perm: 'Group-Position',
    name: 'Master Job Level',
    icon: <UserGroupSetting color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageGroupPosition,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Province',
    exact: true,
    perm: 'Province',
    name: 'Province Management',
    icon: <ProvinceIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageProvince,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Agent-Position',
    exact: true,
    perm: 'Agent-Position',
    name: 'Agent Position (MyHR)',
    icon: <UserGroupSetting color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageAgentPosition,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Report-List',
    exact: true,
    perm: 'Report-List',
    name: 'Master Report',
    icon: <ReportListIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageReport,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/File-List',
    exact: true,
    perm: 'File-List',
    name: 'File List',
    icon: <DocumentIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageFile,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Import-License-Exam-Result',
    exact: true,
    perm: 'Import-License-Exam-Result',
    name: 'Import License Exam Result',
    icon: <ResultIcon color="#fff" />,
    props: { textHeader: 'Import License Exam', apiPath: 'examResult', templatePath: 'getTemplateExamResult' },
    component: BACK_OFFICE_CONTENT.REUSABLE.Import,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Gen-Structure',
    exact: true,
    perm: 'Gen-Structure',
    name: 'Gen Structure',
    icon: <MovePosition color="#fff" size={35} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.GenStructure,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Manage-Consent',
    exact: true,
    perm: 'Manage-Consent',
    name: 'Manage Consent',
    icon: <i className="fa fa-folder-o" style={{ fontSize: '2.25rem', color: '#fff' }} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageConsent,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Master-Welcome-Letter',
    exact: true,
    perm: 'Master-Welcome-Letter',
    name: 'Master Welcome Letter',
    icon: <i className="fa fa-envelope-o" style={{ fontSize: '2.25rem', color: '#fff' }} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageWelcomeLetter,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Master-iRefer-Partner',
    exact: true,
    perm: 'Master-iRefer-Partner',
    name: 'Master-iRefer-Partner',
    icon: <i className="fa fa-envelope-o" style={{ fontSize: '2.25rem', color: '#fff' }} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageiReferParter,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Master-iRefer-User',
    exact: true,
    perm: 'Master-iRefer-User',
    name: 'Master-iRefer-User',
    icon: <i className="fa fa-envelope-o" style={{ fontSize: '2.25rem', color: '#fff' }} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageiReferUser,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/ManageApproveFlow',
    exact: true,
    perm: 'ManageApproveFlow',
    name: 'ManageApproveFlow',
    icon: <i className="fa fa-envelope-o" style={{ fontSize: '2.25rem', color: '#fff' }} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageApproveFlow,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Auto-Terminate',
    exact: true,
    perm: 'Auto-Terminate',
    name: 'Auto Terminate',
    icon: <RejectDocIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.AutoTerminate,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Manage-AT-Template',
    exact: true,
    perm: 'Manage-AT-Template',
    name: 'Manage AT Template',
    icon: <DocumentIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageATTemplate,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Master-Compensation-Scheme',
    exact: true,
    perm: 'Master-Compensation-Scheme',
    name: 'Master Compensation Scheme',
    icon: <CompensationIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.CompensationScheme,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Auto-Terminate-Log',
    exact: true,
    perm: 'Auto-Terminate-Log',
    name: 'Auto Terminate Log',
    icon: <HistoryIcon color="#fff" size={35} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.AutoTerminateLog,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Upload-Terminated-FTE',
    exact: true,
    perm: 'Upload-Terminated-FTE',
    name: 'Upload Terminated FTE',
    icon: <ResultIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.UploadTerminateFTE,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Agent-List-History-Log',
    exact: true,
    perm: 'Agent-List-History-Log',
    name: 'Agent List History Log',
    icon: <HistoryIcon color="#fff" size={35} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.AgentListLog,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Manage-Master-Tele-Area',
    exact: true,
    perm: 'Manage-Master-Tele-Area',
    name: 'Manage Master Tele Area',
    icon: <LocationPointerIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageMasterTeleArea,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Manage-Master-Bank',
    exact: true,
    perm: 'Manage-Master-Bank',
    name: 'Manage Master Bank',
    icon: <i className="fa fa-building" style={{ fontSize: '2.25rem', color: '#fff' }} />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.ManageMasterBank,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Configuration/Configuration',
    exact: true,
    perm: 'Configuration',
    name: 'Configuration',
    icon: <ConfigurationIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.CONFIGURATION.Configuration,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Configuration/Menu',
    exact: true,
    perm: 'Menu',
    name: 'Menu',
    icon: <MenuIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.CONFIGURATION.Menu,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Configuration/Asset',
    exact: true,
    perm: 'Asset',
    name: 'Asset',
    icon: <AssetIcon color="#fff" size={35} />,
    component: BACK_OFFICE_CONTENT.CONFIGURATION.Asset,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Configuration/List-of-value',
    exact: true,
    perm: 'List-of-value',
    name: 'List of Value',
    icon: <ReportListIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.CONFIGURATION.ManageListOfValue,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Configuration/Sf-Area',
    exact: true,
    perm: 'Sf-Area',
    name: 'SF Area',
    icon: <LocationPointerIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.CONFIGURATION.ManageArea,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Configuration/Page-Type',
    exact: true,
    perm: 'Page-Type',
    name: 'Page Type',
    icon: <i className="fa fa-list-alt" style={{ fontSize: '2.25rem', color: '#fff' }} />,
    component: BACK_OFFICE_CONTENT.CONFIGURATION.PageType,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Configuration/Cors',
    exact: true,
    perm: 'Cors',
    name: 'Cors',
    icon: <i className="fa fa-unlock-alt" style={{ fontSize: '2.25rem', color: '#fff' }} />,
    component: BACK_OFFICE_CONTENT.CONFIGURATION.Cors,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/Configuration/Log-Pii',
    exact: true,
    perm: 'Log-Pii',
    name: 'Log-Pii',
    icon: <i className="fa fa-unlock-alt" style={{ fontSize: '2.25rem', color: '#fff' }} />,
    component: BACK_OFFICE_CONTENT.CONFIGURATION.LogPii,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/Back-office/System Administrator/Master-Education',
    exact: true,
    perm: 'Master-Education',
    name: 'Master Education',
    icon: <DocumentIcon color="#fff" />,
    component: BACK_OFFICE_CONTENT.MANAGEMENT.Education,
    header: HEADER.BackOfficeNav
  },
  {
    path: '/*',
    exact: true,
    name: '404',
    type: '404',
    component: FONT_OFFICE_CONTENT.NotFound,
    header: HEADER.HomeHeader
  }
]

export default routes
